<template>
  <div class="payment" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px"></div>
    <block v-if="detail.type == 2">
      <div class="address" v-if="detail.address != null" @click="$router.push('address')" >
        <div class="left">
          <span>{{detail.name}}-</span>
          <span>{{detail.phone}}</span>
        </div>
        <div class="right">
          <font>{{detail.address}}</font>
        </div>
        <img src="~assets/images/icon5.png" />
      </div>

      <div class="address" v-if="detail.address == null" @click="$router.push('address')" >
        <div class="left" v-if="address.length <= 0">
          <span>请选择收货地址</span>
        </div>
        <div class="left" v-if="Object.keys(address).length > 0">
          <span>{{address.name}}</span>
          <span> - {{address.phone}}</span>
        </div>
        <div class="right" v-if="Object.keys(address).length > 0">
          <font>{{address.address}}</font>
        </div>
        <img src="~assets/images/icon5.png" />
      </div>
    </block>

    <div class="pro">
      <h2 class="bussTitle">{{detail.title}}</h2>
      <div class="goods" v-for="(item,i) in detail.content">
        <div class="left">
          <el-image style="width:100%;height:55px; border-radius:5px;" :src="baseUrl+item.img" fit="cover"></el-image>
        </div>
        <div class="right">
          <p>{{item.title}}<span style="padding-left:5px;color:#666;font-size:13px">×{{item.num}}件</span></p>
          <div class="num">{{item.attr}}</div>
          <div class="price">
            <i>￥</i><b>{{item.rate}}</b>
            <div>￥{{item.price}}</div>
          </div>
        </div>
      </div>

      <div class="email" v-if="detail.deposit > 0">
        押金 
        <img src="~assets/images/icon5.png" />
        <span style="color:red">{{detail.deposit}}元</span>
      </div>
      <div class="email">
        订单编号 
        <img src="~assets/images/icon5.png" />
        <span>{{detail.number}}</span>
      </div>
      <div class="email">
        提交时间 
        <img src="~assets/images/icon5.png" />
        <span>{{detail.create_time}}</span>
      </div>
      <div class="email">
        配送方式 
        <img src="~assets/images/icon5.png" />
        <span>{{detail.type == 1 ? '自取' : '快递配送'}}</span>
      </div>
      <div class="email" v-if="detail.type == 2">
        含配送费 
        <img src="~assets/images/icon5.png" />
        <span>{{detail.psf}}元</span>
      </div>
      <div class="email" v-if="detail.type != 1" @click="dzwlfind">
        选择地址围栏 
        <img src="~assets/images/icon5.png" />
        <span>{{wladdress}}</span>
      </div>
      <div class="email" v-if="detail.price <= 0">
        员工下单 
        <img src="~assets/images/icon5.png" />
        <span style="color:#FF751A">所用金额为 ￥{{detail.price}}</span>
      </div>
      <div class="email" @click="coupon" v-if="detail.price > 0">
        抵用劵 
        <img src="~assets/images/icon5.png" />
        <span v-if="total <= 0">暂无抵用劵可用</span>
        <span class="curt" :style="coupon_price > 0 ? 'background:none;color: #f00':''" v-if="total > 0">{{coupon_price > 0 ? '-￥'+coupon_price : total+'张可用'}}</span>
      </div>
      <div class="email" style="border-bottom:none">
        订单备注 
        <textarea v-model="remark" placeholder="标注订单备注"></textarea>
      </div>
    </div>

    <h2 class="payType" v-if="detail.price > 0">支付方式</h2>
    <div class="payMoney" v-if="detail.price > 0">
      <p @click="setPayType(1)" :class="payType == 1 ? 'curt' : ''">
        <img src="~assets/images/wx.png"/>
        微信支付
        <i class="el-icon-success"></i>
      </p>
      <p @click="setPayType(2)" :class="payType == 2 ? 'curt' : ''" style="line-height:50px;">
        <img src="~assets/images/zh.png"/>
        组合支付
        <i class="el-icon-success"></i>
      </p>
      <p @click="setPayType(3)" :class="payType == 3 ? 'curt' : ''">
        <img src="~assets/images/ye.png"/>
        <font>余额支付
        <em>￥{{setCash}}</em>
        </font>
        <i class="el-icon-success"></i>
      </p>
    </div>

    <div style="height:90px"></div>

    <div class="footer1">
      <div class="foot-title">
        <span>
          <i>￥</i><b>{{((detail.price - coupon_price) + (detail.deposit*1)).toFixed(2)}}</b>
        </span>
        <span>共{{detail.num}}件商品</span>
      </div>
      <div v-if="detail.price > 0" class="pay" @click="payment">
        <span>立即支付</span>        
      </div>
      <div v-if="detail.price <= 0" class="pay" @click="yesRk">
        <span>确认入库</span>        
      </div>
    </div>

    <el-drawer
      title="选择地址围栏" :visible.sync="drawer" :direction="direction" size="50%" :withHeader="true">
      <ul>
        <li @click="ce(item.address)" v-for="(item,i) in dzwl">
          <p>{{item.address}}</p>
          <a v-if="wladdress==item.address"><img src="~assets/images/choose2.png" /></a>
          <a v-if="wladdress!=item.address"><img src="~assets/images/choose1.png" /></a>
        </li>
      </ul>
    </el-drawer>
  </div>
</template>

<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        detail:[],
        address:[],
        total:0,
        userData:[],
        radio1: '1',
        coupon_id:0,
        coupon_price:0,
        remark:'',
        dzwl:[],

        type:1,

        wladdress:'请选择围栏地址',
        direction: 'btt',
        drawer:false,
        active:-1,
        payType:1,
        setCash:0
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
      this.getAddress();
      this.getCash();
      if(localStorage.getItem('coupon') != null){
        var c = localStorage.getItem('coupon').split('-');
        this.coupon_id = c[0];
        this.coupon_price = c[1];
        this.type = c[2];
        localStorage.removeItem("coupon");
      }
    },

    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url,total){
        this.$router.push({
          path:url,
          query:{
            id:index,
            use:total
          }
        })
      },
      ce:function(address){
        this.wladdress = address;
        this.drawer = false;
      },
      dzwlfind:function(){
        this.drawer = true;
      },
      agreeChange:function(val){
        if(val == 1){
          this.pay = true;
        }else{
          this.pay = false;
        }
      },

      setPayType:function(inx){
        var price = this.detail.price;
        var coupon_price = this.coupon_price;
        var setCash = this.setCash;
        if(setCash <= 0){
          this.$alert('您选择的支付方式账号余额不足！', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        if((price - coupon_price >= setCash) && inx == 3){
          this.$alert('您账号余额不足够支付该订单，请您切换其他支付方式！', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        if((price - coupon_price <= setCash) && inx == 2){
          this.$alert('您账号余额足够支付改订单，请您切换余额支付方式！', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        this.payType = inx;
      },  
      getCash:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/user/cash',
          data:{
            user_id:that.userData.id
          },
          dataType:'json',
          success:function(data){
            that.setCash = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
      coupon:function(){
        var that = this;
        if(that.total <= 0){
          that.$alert('暂无抵用劵可用','提示');return false
        }
        that.toPush(that.detail.mall_id,'coupon',parseInt(that.detail.price))
      },

      getDetail:function(){
        var that = this;
        var id = this.$route.query.id;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/product/getOrder',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data.data;
          var content = res.rs.content;
          var psf = 0;
          for(var i=0;i<content.length;i++){
            psf += content[i].rate*1
          }
          res.rs.psf = res.rs.price - psf;
          that.detail = res.rs;
          that.type = res.rs.type
          that.total = res.total;
          that.dzwl = res.dzwl;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      getAddress:function(){
        var that = this;
        that.fullscreenLoading = true;
        this.axios({
          method:'post',
          url:that.$host+'home/product/getAddressUser',
          params:{
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          that.address = (res == null ? [] : res);
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      yesRk:function(){
        var that = this;
        var id = this.$route.query.id;
        that.axios({
          method:'post',
          url:that.$host+'home/product/nbygPay',
          params:{
            id:id,
            user_id:that.userData.id,
            remark:that.remark
          }
        }).then(function(response){
          var res = response.data.data;
          if(response.data.status == 200){
            that.$router.push({
              path:'porder',
              query:{
                id:res
              }
            })
          }else{
            that.$alert('支付失败，请重新确认信息后支付！', '提示', {
              confirmButtonText: '确定'
            });
          }
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      payment:function(){
        var that = this;
        var id = this.$route.query.id;
        if(that.detail.type == 2){
          if(that.address.phone == undefined){
            that.$alert('请选择收货地址！', '提示', {
              confirmButtonText: '确定'
            });
            return false;
          }
        }
        
        var address = '';
        var phone = '';
        var name = ''
        if(that.detail.type == 2){
          address = that.address.address;
          phone = that.address.phone;
          name = that.address.name
        }
        that.axios({
          method:'post',
          url:that.$host+'home/product/weixinPay',
          params:{
            id:id,
            user_id:that.userData.id,
            address:address,
            points:that.coupon_id,
            name:name,
            phone:phone,
            remark:that.remark,
            coupon_price:that.coupon_price,
            type:that.type,
            pay_type:that.payType,
            deposit:(that.detail.deposit*1),
            wladdress:(that.wladdress == '' ? '请选择围栏地址' : that.wladdress)
          }
        }).then(function(response){
          var res = response.data.data;
          if(response.data.status == 200){
            if(that.payType == 3){
              window.location.href="http://user.4008005216.com/main/porder";
            }else{
              that.callpay(res);
            }
          }else{
            that.$alert('支付失败，请重新确认信息后支付！', '提示', {
              confirmButtonText: '确定'
            });
          }
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      jsApiCall:function(msg){
        var that = this;
          WeixinJSBridge.invoke(
              'getBrandWCPayRequest',
              {
                "appId":'wxa89a20966e69c2a5',
                "timeStamp":msg.timeStamp,         //时间戳，自1970年以来的秒数     
                "nonceStr":msg.nonceStr, //随机串     
                "package":msg.package,     
                "signType":msg.signType,         //微信签名方式：     
                "paySign":msg.paySign 
              },
              function(res){
                  if(res.err_msg == "get_brand_wcpay_request:ok"){
                    window.location.href="http://user.4008005216.com/main/porder";
                  }else{
                     //返回跳转到订单详情页面
                      alert('支付失败');return false
                  }
              }
          );
      },

      callpay:function(data){
        if (typeof WeixinJSBridge == "undefined"){
          if( document.addEventListener ){
              document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
          }else if (document.attachEvent){
              document.attachEvent('WeixinJSBridgeReady', jsApiCall); 
              document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
          }
        }else{
          this.jsApiCall(data);
        }
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .payment{
    max-width:640px;
    background:#F1F2F5;
    margin:0 auto;
  }
  
  .payment .address{
    background:#fff;
    display:block;
    position: relative;
    background: #FFFFFF;
    border-radius: 10px;
    width:94%;
    margin:0 auto 15px auto;
    padding:10px 0
  }
  .payment .address:after,.payment .goods:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .payment .address img{
    position: absolute;
    right:20px;
    top:50%;
    transform: translateY(-50%);
    width:10px;
  }
  .payment .address .left{
    display:block;
    width:80%;
    height:35px;
    line-height:35px;
  }

  .payment .address .left span:first-child{
    font-size: 16px;
    color: #333333;
    padding-left:15px;
  }
  .payment .address .left span:last-child{
    font-size: 16px;
    color: #666;

  }
  .payment .address .right{
    margin-top:8px;
    display:block;
    width:80%;
  }
  .payment .address .right font{
    font-size: 15px;
    font-family: PingFangSC;
    font-weight: 400;
    color: #666666;
    padding-left:15px;
    padding-bottom:10px;
  }

  .payment .pro{
    background:#fff;
    display:block;
    width:94%;
    border-radius: 6px;
    margin:0 auto;
  }
  .payment .pro .bussTitle{
    font-size:16px;
    width:92%;
    margin:0 auto;
    padding:15px 0 0px 0
  }
  .payment .goods .left{
    float:left;
    width:16%;
    border-radius:5px;
    margin:4% 2% 2% 4%;
  }
  .payment .goods .right{
    float:left;
    margin-top:4%;
    width:73%;
    border-bottom:solid 1px #f5f5f5;
    position: relative;
    min-height:60px;
  }
  .payment .goods .right p{
    letter-spacing:1px;
    font-size:15px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    color:#000;
    width:78%
  }
  .payment .goods .right p font{
    background:#f00;
    color:#fff;
    border-radius:5px;
    font-size:13px;
    position: relative;
    padding:2px;
    top:-2px;
    margin-right:2px
  }
  .payment .goods .right .num{
    font-size: 14px;
    color: #999999;
    padding-top:13px;
  }
  .payment .goods .right .price{
    color:#f00;
    font-size:15px;
    position: absolute;
    top:0;
    right:0;
    text-align:right
  }
  .payment .goods .right .price div{
    font-size:12px;
    color:#999;
    text-decoration: line-through;
  }
  .payment .goods .right .price b{
    color: #f00;
    font-size:18px;
    font-weight:600;
  }

  .payment .goods .right .price i{
    color: #f00;
    font-size:12px;
    font-style:normal
  }
  
  .payment .goods .right .price font{
    color:#666;
    font-size:14px;
    padding-left:8px
  }
  .payment textarea{
    display:inline-block;
    width:70%;
    border:none;
    font-size:15px;
    outline:none;
    vertical-align:top;
    margin-left:18px;
    background:#fff;
    resize: none;
    text-align:right;
  }

  .payment .remark{
    display:block;
    width:94%;
    color:#999;
    font-size:14px;
    letter-spacing:1px;
    margin:0 auto;
    padding:10px 0 15px 0
  }

  .payment .email{
    background:#fff;
    padding:18px 0;
    font-size:15px;
    color:#666;
    display:block;
    width:90%;
    margin:0 auto;
    border-bottom:solid 1px #ebebeb;
  }
  .payment .email span{
    color:#333;
    font-size: 15px;
    float:right;
    font-weight:normal;
    margin-right:8px;

  }
  .payment .email span.curt{
    background:#f00;
    color:#fff;
    padding:2px 5px;
    border-radius:5px;
  }
  .payment .email img{
    float:right;
    width:6px;
    margin-top:4px
  }

  .payment .footer1{
    height: 45px;
    width: 92%;
    border-radius: 55px;
    position: fixed;
    bottom: 20px;
    left: 3%;
    z-index: 1
  }
  .payment .footer1 .foot-title{
    float: left;
    width:65%;
    height:42px;
    background: #000;
    border-radius:40px 0 0 40px;
    padding-top:3px
  }
  .payment .footer1 .foot-title span{
    font-size: 12px;
    color: #fff;
    margin-right:15px;
    display:block;
    margin-left:8%
  }
  .payment .footer1 .foot-title span b{
    color: #fff;
    font-size:18px;
    font-weight:600;
  }

  .payment .footer1 .foot-title span i{
    color: #fff;
    font-size:12px;
    font-style:normal
  }
  
  
  .payment .footer1 .pay{
    float: right;
    width:35%
  }
  .payment .footer1 .pay span{
    float:left;
    height:45px;
    line-height:45px;
    font-size: 15px;
    width:100%;
    color:#fff;
    text-align:center;
    font-weight:bold;
    background:#ff4444;
    border-radius:0 40px 40px 0;
  }

  .payment .choose{
    width:90%;
    margin:0 auto
  }
  .payment .choose label{
    margin-top:15px;
    font-size:22px
  }



  .payment .el-drawer__wrapper ul{
    width:90%;
    margin:0 auto;
  }
  .payment .el-drawer__wrapper li{
    border-bottom:solid 1px #EBF2FF;
    padding:15px 0 10px 0;
    position:relative;
  }
  .payment .el-drawer__wrapper li:last-child{
    border-bottom:none;
  }

  .payment .el-drawer__wrapper li p{
    padding-bottom:7px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    padding-left:45px;
  }
  .payment .el-drawer__wrapper li p:last-child{
    color: #666;
  }

  .payment .el-drawer__wrapper li a{
    position:absolute;
    left:0;
    top:50%;
    transform: translateY(-50%);
    color: #2F78FF;
    font-size:18px;
  }
  .payment .el-drawer__wrapper li a img{
    display:block;
    width:30px;
  }

  .payment .payType{
    width:94%;
    margin:0 auto;
    font-size:13px;
    color:#666;
    font-weight:normal;
    padding:15px 0 8px 0
  }
  .payment .payMoney{
    width:94%;
    margin:0 auto;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
  }
  .payment .payMoney p{
    width:31.5%;
    background:#fff;
    font-size:14px;
    height:50px;
    border-radius: 6px;
  }
  .payment .payMoney p:first-child{
    line-height:50px;
  }
  .payment .payMoney p img{
    width:20px;
    float:left;
    margin:15px 6px 0 6px
  }
  .payment .payMoney p font{
    float:left;
    width:50%;
    margin-top:12px
  }
  .payment .payMoney p font em{
    font-style:normal;
    font-size:12px;
    color:#999
  }
  .payment .payMoney p i{
    float:right;
    font-size:16px;
    color:#ddd;
    margin:17px 6px 0 0
  }

  .payment .payMoney p.curt i{
    color:#ff4444
  }
</style>